// Reusable Control component for form inputs
import React from 'react';

export function Control({ label, children }: { label: React.ReactNode; children: React.ReactNode }) {
  return (
    <label className="block text-sm">
      <div className="mb-2 text-zinc-400">{label}</div>
      {children}
    </label>
  );
}
